module.exports = {
  MultipleAnswer: {
    PluginName: "Multiple Answer",
    content_box_name: "Content ",
    Statement:
      "This is a Multiple Choice question with multiple possible correct answers. You can write here the question statement",
    Question: "Question",
    Answer: "Answer",
    Feedback: "Feedback",
    FeedbackMsg:
      "Here you can provide some feedback about the answer. In order to disable this feature, turn it off in the toolbar",
    TrueFeedbackMsg:
      "Here you can provide some feedback about the true answer. In order to disable this feature, turn it off in the toolbar.",
    FalseFeedbackMsg:
      "Here you can provide some feedback about the false answer. In order to disable this feature, turn it off in the toolbar.",
    ShowFeedback: "Show feedback msg.",
    Number: "Number of answers",
    ShowLettersInsteadOfNumbers: "Numbering",
    ShowLetters: "Letters",
    ShowNumbers: "Numbers",
    AllowPartialScore: "Allow partial score",
    Color: "Color",
    correctAnswerFeedback: "Correct answer",
    None: "None",
    notCount: "This exercise does not add points",
    CheckAnswerText: "Check Answer Button Text",
    TryAgainText: "Try Again Button Text",
    SeeAnswerText: "See Answer Button Text",
    ButtonStyle: "Button Style",
    ButtonBackground: "Button Background Color",
    ButtonTextColor: "Button Text Color",
    ButtonBorderColor: "Button Border Color",
    ButtonBorderWidth: "Button Border Width",
    ButtonBorderRadius: "Button Border Radius",
    ButtonPadding: "Button Padding",
    ButtonFontSize: "Button Font Size",
    ButtonFontWeight: "Button Font Weight",
    ButtonHoverBackground: "Button Hover Background Color",
    tryAgain: "Try Again",
    checkAnswer: "Check Answer",
  },
};
